import axios from "axios";
import { store } from "../store";

const AUTH_ENDPOINTS = ["/auth"];

const axiosCall = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosCall.interceptors.request.use(
  (config) => {
    const token = store.getState().userProfile?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const impersonationToken = store.getState().impersonation?.token;
    if (impersonationToken) {
      config.headers["X-Impersonation-Token"] = impersonationToken;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosCall.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    const isAuthEndpoint = AUTH_ENDPOINTS.some((endpoint) =>
      url.includes(endpoint),
    );

    if (error.response?.status === 401 && !isAuthEndpoint) {
      localStorage.clear();
      window.location.href = "/signin";
    }

    return Promise.reject(error);
  },
);

export default axiosCall;
